module.exports = __webpack_public_path__ + "img/settings.bda0100e.svg";